import { Box, Paper, Typography } from "@mui/material";
import { LocalCarWash } from "@mui/icons-material";
import { useTranslation } from "react-i18next";

interface EmptyStateProps {
  message?: string;
  subMessage?: string;
}

const EmptyState = ({ message, subMessage }: EmptyStateProps) => {
  const { t } = useTranslation();
  return (
    <Paper className="p-6">
      <Box className="text-center">
        <LocalCarWash sx={{ fontSize: 64, color: "text.secondary", mb: 2 }} />
        <Typography variant="h6" color="text.secondary" gutterBottom>
          {message ?? t("emptyState.noWashingCenters")}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          {subMessage ?? t("emptyState.noWashingCentersDesc")}
        </Typography>
      </Box>
    </Paper>
  );
};

export default EmptyState;
